// @flow

import * as React from "react";

import usePageFromStore from "../hooks/usePageFromStore";
import SimpleContentPage from "./SimpleContentPage";
import ClubDetail from "./ClubDetail";
import EventDetail from "./EventDetail";
import ProductDetail from "./ProductDetail";
import Content from "./Content";
import AccountContent from "./AccountContent";
import Listing from "./Listing";
import Sports from "./Sports";
import Campaign from "./Campaign";

import Home from "./Home";
// import ListingPage from "./ListingPage";

import NotFound from "./NotFound";
import actions from "../actions/index.js";

type PropsType = {};

const templateMapping = (page: Object): any => {
    if (page && page.ID) {
        if (page.page_template) {
            switch (page.page_template) {
                // case "templates/listing.php":
                //     return ListingPage;
                case "templates/home.php":
                    return Home;
                case "templates/club-listing.php":
                    return Listing;
                case "templates/event-listing.php":
                    return Listing;
                case "templates/product-listing.php":
                    return Listing;
                case "templates/sport-landing.php":
                    return Sports;
                case "templates/account-content.php":
                    return AccountContent;
                case "templates/campaign.php":
                    return Campaign;
                default:
                    return Content;
            }
        } else if (page.post_type) {
            switch (page.post_type) {
                case "club":
                    return ClubDetail;
                case "event":
                    return EventDetail;
                // case "researchcentres":
                //     return DetailedContentPage;
                // case "researchprojects":
                //     return ResearchProjectDetail;
                // case "researchareas":
                //     return ResearchAreaTemplate;
                default:
                    return SimpleContentPage;
            }
        }
    } else if (page && page.hasOwnProperty("sale_price")) {
        // Product
        return ProductDetail;
    } else if (page && page.length) {
        return null;
    } else {
        return NotFound;
    }
};

const TemplateChooser = (props: PropsType): React.Node => {
    const { page } = usePageFromStore();
    const Component = templateMapping(page);
    if (Component) {
        return <Component key={page.ID} page={page}></Component>;
    }
    return null;
};

TemplateChooser.preload = ({ location, passed }: any): ?Promise<any> => {
    // First fetch the page, then determine which Container component will be rendered,
    // before resolving, first check if those components have a preload method and fire them
    return new Promise((resolve: () => void, reject: any) => {
        if (!passed.store.dispatch) {
            resolve();
        }
        passed.store
            .dispatch(actions.fetchPage(location.pathname, location.search))
            .then(() => {
                const page = passed.store.getState().page[location.pathname];
                const ComponentThatWillRender = templateMapping(page);
                if (
                    ComponentThatWillRender &&
                    ComponentThatWillRender.preload
                ) {
                    // Preload can return null - so need to check for that
                    const preload = ComponentThatWillRender.preload({
                        page,
                        passed,
                        location,
                    });
                    if (preload && preload.then) {
                        preload.then(resolve);
                    } else {
                        resolve();
                    }
                } else {
                    resolve();
                }
            })
            .catch((error: any) => {
                reject(error);
            });
    });
};

export default TemplateChooser;
